module.exports = __webpack_public_path__ + "img/auxiliary-img-3.27c2df2f.png";